const getData = () => {
  return {
    imgIp: 'https://fileserver.qyunf.com/file/server/view?key=',
  }
}

export default {
  getData,
}
